import { ResponsiveContainer, PieChart as RCPieChart, Pie, Cell, Tooltip } from "recharts";

type TProps = {
  companyDashboardData: {
    companyGoal: number;
    invoiceTotalYtd: number;
    divisions: { division_id: number | null; division_label: string; invoice_total_ytd: number }[];
  };
};

const PieChart = ({ companyDashboardData }: TProps) => {
  const COLORS = ["#00C49F", "#FFBB28", "#FF8042", "#0088FE", "#E44D26", "#FF69B4"];

  // Convert total YTD invoice from cents to dollars
  const yearToDate = companyDashboardData.invoiceTotalYtd / 100;

  // Generate division data for the pie chart
  const data = companyDashboardData.divisions
    .filter((division) => division.invoice_total_ytd > 0) // Remove zero-value divisions
    .map((division) => ({
      name: division.division_label,
      value: Math.round(division.invoice_total_ytd / 100), // Convert cents to dollars
    }));

  // If no data, show a default empty chart
  if (data.length === 0) {
    data.push({ name: "No Data", value: 1 });
  }

  return (
    <div className="relative flex flex-col items-center text-sm">
      <ResponsiveContainer width="100%" height={200}>
        <RCPieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            paddingAngle={5}
            isAnimationActive={true}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value: number) => `$${value.toLocaleString()}`} />
        </RCPieChart>
      </ResponsiveContainer>

      {/* Centered Total YTD */}
      <div className="absolute text-white font-bold text-lg top-[50%] translate-y-[-50%]">
        ${yearToDate.toLocaleString()}
      </div>

      {/* Legend */}
      <div className="mt-4 flex flex-wrap justify-center gap-2">
        {data.map((entry, index) => (
          <div key={entry.name} className="text-xs" style={{ color: COLORS[index % COLORS.length] }}>
            <span className="inline-block w-2 h-2 rounded-full mr-1" style={{ backgroundColor: COLORS[index % COLORS.length] }}></span>
            {entry.name} - {((entry.value / yearToDate) * 100).toFixed(1)}%
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChart;
